function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { ROLES_LIST, PERIODS, DATAPLEX_STATES } from '@/js/constants';
import DataplexRuleComponent from '@/apps/data-platform/modules/data_quality_dataplex/components/DataplexRuleComponent';
import dataplex_service from '@/apps/data-platform/services/data_quality/dataplex_service';
import assignments_service from "@/apps/data-platform/services/tables_views/assignments_service";
import DataplexParameterComponent from "@/apps/data-platform/modules/data_quality_dataplex/components/DataplexParameterComponent";
import QualityExecutionDetailComponent from "@/apps/data-platform/modules/data_quality_dataplex/components/QualityExecutionDetailComponent";
import TextFieldCalendarComponent from "@/components/TextFieldCalendarComponent";
import TextFieldRecipientsComponent from "@/components/TextFieldRecipientsComponent";
export default {
  components: {
    DataplexRuleComponent: DataplexRuleComponent,
    DataplexParameterComponent: DataplexParameterComponent,
    TextFieldCalendarComponent: TextFieldCalendarComponent,
    TextFieldRecipientsComponent: TextFieldRecipientsComponent,
    QualityExecutionDetailComponent: QualityExecutionDetailComponent
  },
  data: function data() {
    var _ref;
    return _ref = {
      DATAPLEX_STATES: DATAPLEX_STATES,
      PREFIX: 'INCA_dq_',
      PREFIX_ID: 'inca-dq-',
      tab: 0,
      tab_rule: 0,
      edit: false,
      view: false,
      id: null,
      mode: "create",
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      table_input_valid: null,
      column_selected: {},
      column_ref: {},
      table_input: {},
      execution_selected: {},
      prev_table_input: "",
      last_modification_table: '',
      key_input_table_input_last: 1,
      quality: {
        region: 'us-central1',
        table_input: '',
        cron_utc: 'UTC-5',
        cron_type: 'UNIQUE',
        scope: 'FULL'
      },
      quality_selected: {},
      qualities: [],
      qualities_to_filter: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      executions: [],
      columns: [],
      pagination_executions: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1,
        sort_by: ['startTime'],
        sort_desc: [true]
      },
      pagination_execution_detail: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      table_columns: [],
      quality_rules: [],
      rule: {},
      view_rule: false,
      edit_rule: false
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "execution_selected", {}), "key_table_executions", 1), "key_table_execution_details", 1), "pagination_details", {
      total: 0,
      limit: 10,
      current: 1
    }), "pagination_columns", {
      total: 0,
      limit: 10,
      current: 1
    }), "add_rule", false), "key_input_table_input", 1), "key_table_columns", 1), "key_form", 1), "key_data_scan_id", 1), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "PERIODS", PERIODS), "headers_details", [{
      value: 'column',
      text: 'Columna'
    }, {
      value: 'result',
      text: 'Resultado'
    }]), "alcances", [{
      text: 'Datos Completos',
      value: 'FULL'
    }, {
      text: 'Incremental',
      value: 'INCREMENTAL'
    }]), "scope_periods", [{
      text: 'SEMANAL',
      value: PERIODS.ONE_WEEK
    }, {
      text: 'QUINCENAL',
      value: PERIODS.BIWEEKLY
    }, {
      text: 'MENSUAL',
      value: PERIODS.ONE_MONTH
    }, {
      text: 'SEMESTRAL',
      value: PERIODS.SIX_MONTH
    }]), "cron_periods", [{
      text: 'SEMANAL',
      value: PERIODS.ONE_WEEK
    }, {
      text: 'QUINCENAL',
      value: PERIODS.BIWEEKLY
    }, {
      text: 'MENSUAL',
      value: PERIODS.ONE_MONTH
    }, {
      text: 'SEMESTRAL',
      value: PERIODS.SIX_MONTH
    }]), "cron_hours", []), "cron_days", []), "cron_days_week", [{
      text: 'Lunes',
      value: 1
    }, {
      text: 'Martes',
      value: 2
    }, {
      text: 'Miercoles',
      value: 3
    }, {
      text: 'Jueves',
      value: 4
    }, {
      text: 'Viernes',
      value: 5
    }, {
      text: 'Sabado',
      value: 6
    }, {
      text: 'Domingo',
      value: 7
    }]), "matrix", []), "header_details", [{
      text: 'Columna',
      value: 'rule.column'
    }, {
      text: 'Regla',
      value: 'rule_inca.name'
    }, {
      text: 'Estado',
      value: 'passed'
    }, {
      text: 'Evaluación',
      value: 'expectation'
    }, {
      text: 'Dimensión',
      value: 'dimension'
    }, {
      text: 'Parámetros',
      value: 'parameters'
    }, {
      text: 'Filas con Errores',
      value: 'rowCount'
    }, {
      text: 'Umbral',
      value: 'threshold'
    }]), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "custom_error", {
      table_input: {}
    }), "numRowsTable", 0), "numRowsAllowed", 5000000), "rules", {
      display_name: [function (v) {
        return !!v || 'El campo es requerido.';
      }, function (v) {
        return v && v.length <= 256 || 'Menor o igual a 256 caracteres.';
      }],
      description: [function (v) {
        return v == "" || v == undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
      }],
      data_scan_id: [function (v) {
        return !!v || 'El campo es requerido.';
      }, function (v) {
        return v && v.length <= 63 || 'Menor o igual a 63 caracteres.';
      }, function (v) {
        return /^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/.test(v) || 'Solo minúsculas, empieza con una letra, puede contener letras, numero o guiones, debe terminar con una letra o número.';
      }],
      table_input: [function (v) {
        return !!v || 'El campo es requerido.';
      }, function (v) {
        return /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
      }],
      table_output: [function (v) {
        return v == "" || v == undefined || v == null || /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
      }]
    });
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'dataplex_rules', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers_columns: function headers_columns() {
      if (this.view) return [{
        value: 'column',
        text: this.traductor('data_quality.dataplex.quality.column_field.column')
      }, {
        value: 'rule.name',
        text: this.traductor('data_quality.dataplex.quality.column_field.rule')
      }, {
        value: 'expectation',
        text: this.traductor('data_quality.dataplex.quality.column_field.rule_type')
      }, {
        value: 'dimension',
        text: this.traductor('data_quality.dataplex.quality.column_field.dimension')
      }, {
        value: 'parameters',
        text: this.traductor('data_quality.dataplex.quality.column_field.parameters')
      }, {
        value: 'rule.threshold',
        text: this.traductor('data_quality.dataplex.quality.column_field.threashold')
      }];else {
        return [{
          value: 'column',
          text: this.traductor('data_quality.dataplex.quality.column_field.column')
        }, {
          value: 'rule.name',
          text: this.traductor('data_quality.dataplex.quality.column_field.rule')
        }, {
          value: 'expectation',
          text: this.traductor('data_quality.dataplex.quality.column_field.rule_type')
        }, {
          value: 'dimension',
          text: this.traductor('data_quality.dataplex.quality.column_field.dimension')
        }, {
          value: 'parameters',
          text: this.traductor('data_quality.dataplex.quality.column_field.parameters')
        }, {
          value: 'rule.threshold',
          text: this.traductor('data_quality.dataplex.quality.column_field.threashold')
        }, {
          value: 'actions',
          text: this.traductor('data_quality.dataplex.quality.column_field.actions')
        }];
      }
    },
    headers_executions: function headers_executions() {
      return [{
        value: 'uid',
        text: 'UID'
      }, {
        value: 'state',
        text: this.traductor('data_quality.dataplex.quality.execution_field.state')
      }, {
        value: 'startTime',
        text: this.traductor('data_quality.dataplex.quality.execution_field.date_init')
      }, {
        value: 'endTime',
        text: this.traductor('data_quality.dataplex.quality.execution_field.date_end')
      }, {
        value: 'actions',
        text: this.traductor('data_quality.dataplex.quality.execution_field.actions')
      }];
    },
    time_columns: function time_columns() {
      return this.table_input && this.table_input.schema ? this.table_input.schema.fields.filter(function (x) {
        return x.type == "DATE" || x.type == "DATETIME";
      }) : [];
    }
  }),
  created: function created() {
    if (!this.has_dataplex_active) {
      this.$router.push({
        name: 'HomePage'
      });
      return;
    }
    if (!this.dataplex_rules || this.dataplex_rules.length == 0) {
      this.listarRules();
    }
    this.id = this.$router.currentRoute.params.id;
    this.mode = this.$route.meta.mode;
    if (this.mode == "edit") this.edit = true;
    if (this.mode == "view") this.view = true;
    if (this.id) {
      this.getQuality();
    }
    for (var i = 0; i < 24; i++) {
      this.cron_hours.push({
        text: ("" + i).padStart(2, '0') + ":00",
        value: i
      });
    }
    for (var _i = 0; _i < 31; _i++) this.cron_days.push({
      text: _i + 1,
      value: _i + 1
    });
  },
  methods: {
    nextTab: function nextTab() {
      if (!this.$refs["form_quality"].validate()) return;
      this.tab += 1;
    },
    prevTab: function prevTab() {
      if (this.tab > 0) this.tab -= 1;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    formatDate: function formatDate(data) {
      if (data) return new Date(data).toLocaleString();
      return "";
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    getQuality: function getQuality() {
      var _this = this;
      dataplex_service.getQuality({
        id: this.id
      }).then(function (response) {
        _this.quality = response.data;
        _this.columns = response.data.columns;
        _this.onDetailTable();
        _this.listExecutions();
      });
    },
    listarRules: function listarRules() {
      var _this2 = this;
      dataplex_service.getRules({}).then(function (response) {
        _this2.$store.commit('data-platform/setDataplexRules', response.data);
      });
    },
    onSearch: function onSearch() {
      var _this3 = this;
      this.qualities = Object.assign([], this.qualities_to_filter);
      if (this.filters.email) {
        this.qualities = this.qualities.filter(function (x) {
          return x.email.toUpperCase().indexOf(_this3.filters.email.toUpperCase()) != -1;
        });
      }
      if (this.filters.domain) {
        this.qualities = this.qualities.filter(function (x) {
          return x.domain.toUpperCase().indexOf(_this3.filters.domain.toUpperCase()) != -1;
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.qualities = Object.assign([], this.qualities_to_filter);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
      this.list_qualities();
    },
    list_qualities: function list_qualities() {
      var _this4 = this;
      dataplex_service.getQualities({}).then(function (response) {
        _this4.qualities = response.data;
        _this4.qualities_to_filter = Object.assign([], response.data);
        _this4.pagination.total = _this4.qualities.length;
      });
    },
    openDialogCreate: function openDialogCreate() {
      this.edit = false;
      this.view = false;
      this.quality = {};
      this.$refs["DIALOG_QUALITY"].onOpen();
    },
    onValidateForm: function onValidateForm() {
      if (this.quality.table_input.split(".").length != 3) {
        tasks.toast.error("El formato de la tabla de entrada no es correcta 'project.dataset.table'");
        return false;
      }
      if (this.quality.table_output) {
        if (this.quality.table_output.split(".").length != 3) {
          tasks.toast.error("El formato de la tabla de salida no es correcta 'project.dataset.table'");
          return false;
        }
      }
      return true;
    },
    updateQuality: function updateQuality() {
      var _this5 = this;
      dataplex_service.updateQuality(this.quality).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this5.$refs["DIALOG_QUALITY"].onClose();
          _this5.onLimpiar();
        } else {
          tasks.toast.error("No se pudo guardar el registro.");
        }
      });
    },
    onViewQuality: function onViewQuality(item) {
      this.view = true;
      this.edit = false;
      this.quality = Object.assign({}, item);
      this.$refs["DIALOG_QUALITY"].onOpen();
    },
    onEditQuality: function onEditQuality(item) {
      this.view = false;
      this.edit = true;
      this.quality = Object.assign({}, item);
      this.$refs["DIALOG_QUALITY"].onOpen();
    },
    onRemoveQuality: function onRemoveQuality(item) {
      this.quality_selected = item;
      this.$refs["DIALOG_REMOVE_QUALITY"].onOpen();
    },
    onConfirmRemoveQuality: function onConfirmRemoveQuality(value) {
      var _this6 = this;
      if (value) {
        dataplex_service.removeQuality(this.quality_selected).then(function (response) {
          if (response.success) {
            tasks.toast.success("El registro se eliminó correctamente.");
            _this6.$refs["DIALOG_REMOVE_QUALITY"].onClose();
            _this6.onLimpiar();
          } else {
            tasks.toast.error("No se pudo eliminar el registro.");
          }
        });
      } else {
        this.$refs["DIALOG_REMOVE_QUALITY"].onClose();
      }
    },
    executeQuality: function executeQuality(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs["DIALOG_CONFIRM_EXECUTION"].onOpen();
    },
    onConfirmExecution: function onConfirmExecution(value) {
      var _this7 = this;
      if (value) {
        dataplex_service.executeQuality(this.item_selected).then(function (response) {
          if (response.success) {
            tasks.toast.success("Se ha lanzado la ejecución, tomará algunos minutos en completar.");
            _this7.$refs["DIALOG_CONFIRM_EXECUTION"].onClose();
          } else {
            tasks.toast.error("No se ha podigo ejecutar el registro.");
          }
        });
      } else {
        this.$refs["DIALOG_CONFIRM_EXECUTION"].onClose();
      }
    },
    onOpenListExecutions: function onOpenListExecutions(item) {
      this.item_selected = Object.assign({}, item);
      this.listExecutions();
    },
    listExecutions: function listExecutions() {
      var _this8 = this;
      this.item_selected = {
        "id": this.id
      };
      dataplex_service.listQualityExecutions(this.item_selected).then(function (response) {
        _this8.executions = response.data;
        _this8.pagination_executions.total = _this8.executions.length;
        _this8.key_table_executions += 1;
      });
    },
    onPingExecution: function onPingExecution(item) {
      var _this9 = this;
      var data = {
        "quality_id": this.item_selected.id,
        "execution_id": item.id
      };
      dataplex_service.pingQualityExecution(data).then(function (response) {
        if (response.success) {
          item = response.data;
          _this9.listExecutions();
        }
      });
    },
    onViewDetailExecution: function onViewDetailExecution(item) {
      this.execution_selected = item;
      var rules_inca = {};
      if (this.execution_selected.columns) {
        this.execution_selected.columns.forEach(function (c) {
          rules_inca[c.column] = c.rule;
        });
      }
      if (this.execution_selected.dataQualityResult && this.execution_selected.dataQualityResult.rules) {
        /*this.execution_selected.dataQualityResult.rules.forEach(r => {
            r["rule_inca"] = rules_inca[r.rule.column]
        })*/
        if (this.execution_selected.columns) for (var i = 0; i < this.execution_selected.dataQualityResult.rules.length; i++) {
          this.execution_selected.dataQualityResult.rules[i].rule_inca = this.execution_selected.columns[i].rule;
        }
      }
      console.log(this.execution_selected);
      this.$refs["DIALOG_DETAIL_EXECUTION"].onOpen();
    },
    onCloseDetail: function onCloseDetail() {
      this.show_detail = false;
    },
    objectToHtmlList: function objectToHtmlList(obj) {
      function createList(item) {
        var html = '<ul>';
        for (var key in item) {
          if (item.hasOwnProperty(key)) {
            html += "<li><strong>".concat(key, ":</strong> ");
            if (_typeof(item[key]) === 'object' && !Array.isArray(item[key])) {
              // Recursively create list for nested objects
              html += createList(item[key]);
            } else if (Array.isArray(item[key])) {
              // Create list for array elements
              html += '<ul>';
              item[key].forEach(function (element, index) {
                html += "<li>[".concat(index, "] ").concat(_typeof(element) === 'object' ? createList(element) : element, "</li>");
              });
              html += '</ul>';
            } else {
              // Add primitive values
              html += item[key];
            }
            html += '</li>';
          }
        }
        html += '</ul>';
        return html;
      }
      return createList(obj);
    },
    onAddRule: function onAddRule() {},
    onChangeTableInput: function onChangeTableInput(event) {},
    onDetailTable: function onDetailTable() {
      var _this0 = this;
      console.log(this.quality.table_input, this.prev_table_input);
      if (this.quality.table_input == this.prev_table_input) return;
      this.prev_table_input = "" + this.quality.table_input;
      var table = this.quality.table_input.split(".");
      if (table.length != 3) return;
      var data = {
        tables: [{
          domain_table: window.userInfo.domain,
          projectId: table[0],
          datasetId: table[1],
          tableId: table[2],
          source: "bigquery"
        }]
      };
      this.custom_error.table_input.loading = true;
      assignments_service.getTablesDetails(data).then(function (response) {
        _this0.custom_error.table_input.loading = false;
        if (Object.keys(response.data).indexOf(table[0] + ":" + table[1] + "." + table[2]) != -1) {
          var item = response.data[table[0] + ":" + table[1] + "." + table[2]];
          if (item.id) {
            console.log("Encontrado: ");
            _this0.numRowsTable = item.numRows;
            _this0.table_input_valid = true;
            _this0.custom_error.table_input.error = false;
            _this0.custom_error.table_input.message = "";
            _this0.table_input = response.data[table[0] + ":" + table[1] + "." + table[2]];
            _this0.last_modification_table = item.lastModifiedTime ? utils.formatDateTime(utils.timestampToDate(Number(item.lastModifiedTime))) : '';
            _this0.key_input_table_input_last += 1;
          } else {
            _this0.table_input_valid = false;
            _this0.custom_error.table_input.error = true;
            _this0.custom_error.table_input.message = "La tabla no es válida o no tiene acceso.";
          }
        } else {
          _this0.table_input_valid = false;
          _this0.custom_error.table_input.error = true;
          _this0.custom_error.table_input.message = "La tabla no es válida o no tiene acceso.";
        }
        _this0.key_input_table_input += 1;
      });
    },
    openDialogAddColumn: function openDialogAddColumn() {
      this.edit_rule = false;
      this.view_rule = false;
      this.column_selected = {};
      this.$refs["DIALOG_ADD_COLUMN"].onOpen();
    },
    addColumn: function addColumn() {
      var _this1 = this;
      if (!this.$refs.form_rule_add.validate()) {
        return;
      }
      console.log(this.column_selected);
      this.matrix.forEach(function (ma) {
        _this1.columns.push(Object.assign({}, ma));
      });
      /*this.column_selected.columns.forEach(x => {
          this.column_selected.rules.forEach(y => {
              let column = {
                  column: "" + x,
                  rule: Object.assign({}, y)
              }
              this.columns.push(column)
          })
      })*/
      this.$refs["DIALOG_ADD_COLUMN"].onClose();
    },
    onEditColumn: function onEditColumn(item) {
      this.column_ref = item;
      this.edit_rule = true;
      this.view_rule = false;
      this.column_selected = {};
      this.column_selected.column = "" + item.column;
      this.column_selected.rule = Object.assign({}, item.rule);
      this.$refs["DIALOG_ADD_COLUMN"].onOpen();
    },
    onViewColumn: function onViewColumn(item) {
      this.column_ref = item;
      this.view_rule = true;
      this.edit_rule = false;
      this.column_selected = {};
      this.column_selected.column = "" + item.column;
      this.column_selected.rule = Object.assign({}, item.rule);
      this.$refs["DIALOG_ADD_COLUMN"].onOpen();
    },
    editColumn: function editColumn() {
      if (!this.$refs.form_rule_add.validate()) {
        return;
      }
      this.column_ref.rule = Object.assign({}, this.column_selected.rule);
      this.$refs["DIALOG_ADD_COLUMN"].onClose();
    },
    onRemoveColumn: function onRemoveColumn(item) {
      var index = this.columns.indexOf(item);
      if (index != -1) {
        this.columns.splice(index, 1);
        this.key_table_columns += 1;
      }
    },
    idNameLine: function idNameLine(name) {
      if (name.startsWith('-')) {
        name = name.substring(1);
      }
      if (name.endsWith('-')) {
        name = name.slice(0, -1);
      }
      if (name.startsWith('-') || name.endsWith('-')) {
        name = this.idNameLine(name);
      }
      return name;
    },
    onChangeName: function onChangeName(event) {
      if (this.mode != "create") return;
      //console.log(event, this.quality.display_name)
      var name = "" + this.quality.display_name;
      name = name.toLowerCase();
      name = name.replace(" ", "-");
      name = name.replace(/[^a-zA-Z0-9]/g, '-');
      name = name.replace("--", "-");
      name = name.replace("--", "-");
      name = name.replace("--", "-");
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      name = this.idNameLine(name);
      this.quality.data_scan_id = this.PREFIX_ID + "" + name;
      //console.log(this.quality.data_scan_id)
      this.key_data_scan_id += 1;
      //this.key_form += 1
    },
    onUpdateQuality: function onUpdateQuality() {
      //console.log(this.quality)
      //console.log(this.columns)
      if (!this.$refs["form_quality"].validate()) return;
      if (this.columns.length == 0) {
        tasks.toast.error("Debe agregar al menos una columna.");
        return;
      }
      this.quality["columns"] = this.columns;
      dataplex_service.updateQuality(this.quality).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onSaveQuality: function onSaveQuality() {
      var _this10 = this;
      console.log(this.quality);
      console.log(this.columns);
      if (!this.$refs["form_quality"].validate()) return;
      if (this.columns.length == 0) {
        tasks.toast.error("Debe agregar al menos una columna.");
        return;
      }
      this.quality["columns"] = this.columns;
      this.quality.display_name = this.PREFIX + this.quality.display_name;
      dataplex_service.createQuality(this.quality).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this10.onCancelar();
        } else {
          _this10.quality.display_name = _this10.quality.display_name.slice(_this10.PREFIX.length);
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onCancelar: function onCancelar() {
      this.$router.push({
        name: 'DataQualityPage'
      });
    },
    onSelectColumn: function onSelectColumn(event) {
      this.onBuildMatrix();
    },
    onSelectRule: function onSelectRule(event) {
      this.onBuildMatrix();
    },
    onBuildMatrix: function onBuildMatrix() {
      var _this11 = this;
      this.matrix = [];
      if (this.column_selected.columns && this.column_selected.rules) this.column_selected.columns.forEach(function (col) {
        _this11.column_selected.rules.forEach(function (rule) {
          var rule2 = Object.assign({}, rule);
          rule2.value = rule2.value.replace("{column}", col);
          _this11.matrix.push({
            column: "" + col,
            rule: Object.assign({}, rule2)
          });
        });
      });
    }
  }
};